import React from 'react';
import PropTypes from 'prop-types';

import { Skeleton } from 'components/common/skeleton';

const variants = {
    bestRate: 'best-rate',
};

const SkeletonSidebarSection = ({ variant, expanded }) => {
    return (
        <div
            className="ab-sidebar-section--skeleton"
            style={{ borderBottom: '1px solid #d9e2e8' }}
        >
            {variant === variants.bestRate && (
                <>
                    <Skeleton width={'50%'} height={14} mb={18} mt={18} />

                    <Skeleton width={'100%'} height={58} mb={10} />
                    <Skeleton width={'100%'} height={58} mb={10} />

                    <div
                        style={{
                            display: 'flex',
                            marginBottom: 18,
                            marginTop: 18,
                        }}
                    >
                        <Skeleton width={'70%'} height={14} />
                        <Skeleton width={'20%'} height={16} ml={'auto'} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            marginBottom: 18,
                            marginTop: 18,
                        }}
                    >
                        <Skeleton width={'70%'} height={14} />
                        <Skeleton width={'20%'} height={16} ml={'auto'} />
                    </div>
                </>
            )}
            {expanded && !variant && (
                <>
                    <Skeleton width={'50%'} height={14} mb={18} mt={18} />

                    <div style={{ display: 'flex', marginBottom: 18 }}>
                        <Skeleton width={'62.5%'} height={16} />
                        <Skeleton width={'20%'} height={16} ml={'auto'} />
                    </div>

                    <div style={{ display: 'flex', marginBottom: 18 }}>
                        <Skeleton width={'62.5%'} height={16} />
                        <Skeleton width={'20%'} height={16} ml={'auto'} />
                    </div>

                    <div style={{ display: 'flex', marginBottom: 18 }}>
                        <Skeleton width={'31%'} height={14} />
                        <Skeleton width={'20%'} height={16} ml={'auto'} />
                    </div>
                </>
            )}

            {!expanded && !variant && (
                <div
                    style={{ display: 'flex', marginBottom: 18, marginTop: 18 }}
                >
                    <Skeleton width={'70%'} height={14} />
                    <Skeleton width={'20%'} height={16} ml={'auto'} />
                </div>
            )}
        </div>
    );
};

SkeletonSidebarSection.propTypes = {
    expanded: PropTypes.bool,
    variant: PropTypes.oneOf([...Object.values(variants)]),
};

export default SkeletonSidebarSection;
